"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodlustAbilityHandler = exports.BloodlustActorAbilityFactory = exports.BloodlustAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BloodlustAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Bloodlust;
        this.__typeName = "Bloodlust";
    }
}
exports.BloodlustAbilityArgs = BloodlustAbilityArgs;
let BloodlustActorAbilityFactory = class BloodlustActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Bloodlust", "Self", 4);
    }
};
BloodlustActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Bloodlust")
], BloodlustActorAbilityFactory);
exports.BloodlustActorAbilityFactory = BloodlustActorAbilityFactory;
let BloodlustAbilityHandler = class BloodlustAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(3),
                    // TODO: marker effect
                    effect: new core_1.BloodlustEffectArgs(),
                    onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "chest"), "BlueCirclingLightning"))
                });
            }
        });
    }
};
BloodlustAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Bloodlust)
], BloodlustAbilityHandler);
exports.BloodlustAbilityHandler = BloodlustAbilityHandler;
